import { Component } from '@angular/core';

@Component({
  selector: 'app-my-favorites',
  templateUrl: './my-favorites.component.html',
  styleUrls: ['./my-favorites.component.scss']
})
export class MyFavoritesComponent {
  topBarTitle:string = 'My Favorites';
  ngOnInit(){
    
  }
}
